// Project Management Skills organized by subcategories
export const PROJECT_MANAGEMENT_SKILLS_CATEGORIES = [
  {
    name: 'Project Planning',
    skills: [
      'Project Scope Management', 'Requirements Analysis', 'Project Charter',
      'Work Breakdown Structure', 'Project Timeline', 'Resource Planning',
      'Budget Planning', 'Risk Assessment', 'Stakeholder Analysis',
      'Project Strategy', 'Feasibility Studies', 'Project Documentation',
      'Planning Tools', 'Project Goals', 'Success Criteria'
    ]
  },
  {
    name: 'Project Execution',
    skills: [
      'Project Implementation', 'Task Management', 'Resource Allocation',
      'Team Coordination', 'Progress Monitoring', 'Quality Control',
      'Change Management', 'Issue Resolution', 'Stakeholder Management',
      'Project Controls', 'Performance Tracking', 'Risk Mitigation',
      'Project Communication', 'Decision Making', 'Problem Solving'
    ]
  },
  {
    name: 'Resource Management',
    skills: [
      'Resource Allocation', 'Team Management', 'Budget Management',
      'Equipment Management', 'Material Planning', 'Vendor Management',
      'Resource Optimization', 'Capacity Planning', 'Cost Control',
      'Resource Scheduling', 'Performance Management', 'Resource Forecasting',
      'Resource Analysis', 'Efficiency Planning', 'Resource Strategy'
    ]
  },
  {
    name: 'Risk Management',
    skills: [
      'Risk Identification', 'Risk Analysis', 'Risk Mitigation',
      'Risk Monitoring', 'Contingency Planning', 'Issue Management',
      'Risk Assessment', 'Risk Strategy', 'Crisis Management',
      'Risk Documentation', 'Risk Control', 'Risk Communication',
      'Risk Reporting', 'Risk Reviews', 'Risk Prevention'
    ]
  },
  {
    name: 'Quality Management',
    skills: [
      'Quality Planning', 'Quality Assurance', 'Quality Control',
      'Process Improvement', 'Quality Standards', 'Performance Metrics',
      'Quality Tools', 'Quality Audits', 'Quality Documentation',
      'Quality Reviews', 'Quality Strategy', 'Quality Training',
      'Quality Analysis', 'Quality Reporting', 'Continuous Improvement'
    ]
  },
  {
    name: 'Communication Management',
    skills: [
      'Stakeholder Communication', 'Team Communication', 'Progress Reporting',
      'Meeting Management', 'Presentation Skills', 'Documentation',
      'Communication Planning', 'Status Updates', 'Feedback Management',
      'Communication Tools', 'Information Distribution', 'Communication Strategy',
      'Conflict Resolution', 'Relationship Building', 'Negotiation Skills'
    ]
  },
  {
    name: 'Schedule Management',
    skills: [
      'Timeline Development', 'Schedule Control', 'Milestone Planning',
      'Critical Path Analysis', 'Schedule Optimization', 'Progress Tracking',
      'Schedule Updates', 'Timeline Management', 'Dependency Management',
      'Schedule Risk', 'Schedule Reporting', 'Schedule Recovery',
      'Schedule Tools', 'Schedule Strategy', 'Time Management'
    ]
  },
  {
    name: 'Cost Management',
    skills: [
      'Budget Planning', 'Cost Control', 'Financial Analysis',
      'Cost Estimation', 'Budget Tracking', 'Expense Management',
      'Cost Optimization', 'Financial Reporting', 'ROI Analysis',
      'Cost Forecasting', 'Budget Reviews', 'Cost Strategy',
      'Value Analysis', 'Cost Documentation', 'Financial Planning'
    ]
  },
  {
    name: 'Stakeholder Management',
    skills: [
      'Stakeholder Analysis', 'Stakeholder Engagement', 'Relationship Management',
      'Expectation Management', 'Stakeholder Communication', 'Influence Management',
      'Stakeholder Strategy', 'Conflict Resolution', 'Partnership Building',
      'Stakeholder Reporting', 'Stakeholder Alignment', 'Interest Management',
      'Impact Analysis', 'Stakeholder Tools', 'Relationship Building'
    ]
  },
  {
    name: 'Team Leadership',
    skills: [
      'Team Building', 'Performance Management', 'Team Development',
      'Motivation Skills', 'Conflict Resolution', 'Leadership Skills',
      'Team Coordination', 'Staff Management', 'Team Communication',
      'Team Planning', 'Team Strategy', 'Performance Evaluation',
      'Team Culture', 'Team Effectiveness', 'Leadership Development'
    ]
  },
  {
    name: 'Project Tools',
    skills: [
      'Project Software', 'Collaboration Tools', 'Planning Tools',
      'Tracking Systems', 'Documentation Tools', 'Analysis Software',
      'Reporting Tools', 'Communication Platforms', 'Management Systems',
      'Scheduling Tools', 'Risk Tools', 'Quality Tools',
      'Cost Tools', 'Resource Tools', 'Performance Tools'
    ]
  },
  {
    name: 'Project Methodology',
    skills: [
      'Agile Methods', 'Waterfall Method', 'Scrum Framework',
      'Kanban System', 'Lean Principles', 'Prince2 Methodology',
      'PMI Standards', 'Hybrid Approaches', 'Project Frameworks',
      'Best Practices', 'Process Models', 'Methodology Selection',
      'Implementation Methods', 'Adaptation Skills', 'Methodology Tools'
    ]
  }
];

// Export flattened list for backward compatibility
export const PROJECT_MANAGEMENT_SKILLS = PROJECT_MANAGEMENT_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
